import type { AppConfig } from '@services/config.service';
import { UAParser } from 'ua-parser-js';

const playStoreLinkPrefix = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=';
const defaultAppStoreCountryCode = 'x';
const appStoreCountryCodeByLanguageCode: Record<string, string> = {
	da: 'dk',
	de: 'de',
	fi: 'fi',
	hr: 'hr',
	nb: 'no',
	nl: 'nl',
	no: 'no',
	'pt-br': 'br',
	sv: 'se',
	'en-gb': 'gb',
};

export function createPlayStoreDownloadLink(androidPackageId: string): string {
	return `${playStoreLinkPrefix}${androidPackageId}`;
}

export function createAppStoreDownloadLink(appStoreId: string, languageCode?: string | null): string {
	const normalizedLanguageCode = languageCode?.toLowerCase().replace(/_/g, '-');
	const localeParts = normalizedLanguageCode?.split(/[-_]/);
	const baseLanguageCode = localeParts?.[0];
	const regionCode = localeParts?.[1];
	const countryCode =
		(normalizedLanguageCode != null ? appStoreCountryCodeByLanguageCode[normalizedLanguageCode] : null) ??
		(baseLanguageCode != null ? appStoreCountryCodeByLanguageCode[baseLanguageCode] : null) ??
		(regionCode != null && /^[a-z]{2}$/.test(regionCode) ? regionCode : null) ??
		defaultAppStoreCountryCode;

	return `https://apps.apple.com/${countryCode}/app/id${appStoreId}`;
}

export function getAppDownloadLink(appConfig: AppConfig | null): string | null {
	if (appConfig == null) return null;

	const parser = new UAParser();
	const userOS = parser.getOS().name;

	if (userOS === 'Android' && appConfig.androidPackageId != null) {
		return appConfig.androidDownloadLink ?? createPlayStoreDownloadLink(appConfig.androidPackageId);
	}

	if (userOS === 'iOS' && appConfig.appStoreId != null) {
		return appConfig.iosDownloadLink ?? createAppStoreDownloadLink(appConfig.appStoreId);
	}

	return null;
}
